import React, { useState } from "react";
import "../../../assets/styles/main.scss";

export const ScreenShareDeniedPopup = ({
  isScreenShareDeniedOpen,
  onScreenShareDeniedClose,
  topic,
  header,
  content,
}) => {
  return (
    <div
      className={`modal sharing-denied-popup ${
        isScreenShareDeniedOpen ? "active" : ""
      }`}
    >
      <div className="modal-background"></div>
      <div className="modal-container with-header">
        <div className="modal-header">
          <h3 className="flex">{topic}</h3>
          <span className="close-btn" onClick={onScreenShareDeniedClose}>
            &times;
          </span>
        </div>
        <div className="modal-content flex">
          <div className="screen-sharing-info">
            <h3>{header}</h3>
            <p>{content}</p>
          </div>
        </div>
        <div className="modal-footer flex">
          <div className="flex">
            <button
              type="button"
              className="default-btn"
              onClick={onScreenShareDeniedClose}
            >
              Ok
            </button>
            {/* <button type="button" className="warning-button">End Session</button> */}
          </div>
        </div>
      </div>
    </div>
  );
};
